<app-hvb-header></app-hvb-header>
<hr class="mb-0">
<div class="imprint-page">
  <div class="title">
    {{'imprintPage.title' | translate}}
  </div>
  <div class="content">
    <div>
      <b>{{'imprintPage.leftColumn.title' | translate}}</b>
      {{'imprintPage.leftColumn.name' | translate}}<br>
      {{'imprintPage.leftColumn.street' | translate}}<br>
      {{'imprintPage.leftColumn.postalCode' | translate}}<br>
      {{'imprintPage.leftColumn.telephone' | translate}}<br>
      {{'imprintPage.leftColumn.fax' | translate}}<br>
      {{'imprintPage.leftColumn.email' | translate}}<br><br>
      {{'imprintPage.leftColumn.registryCourt' | translate}}<br>
      {{'imprintPage.leftColumn.court' | translate}}<br><br>
      {{'imprintPage.leftColumn.clubNumber' | translate}}<br>
      {{'imprintPage.leftColumn.number' | translate}}<br><br>
      {{'imprintPage.leftColumn.clubNumber' | translate}}<br>
      {{'imprintPage.leftColumn.board' | translate}}<br>
      {{'imprintPage.leftColumn.svenjaRichartz' | translate}}<br>
      {{'imprintPage.leftColumn.christenCarstens' | translate}}<br>
      {{'imprintPage.leftColumn.juergenHahn' | translate}}<br><br>
      {{'imprintPage.leftColumn.responsibleForTheContent' | translate}}<br>
      {{'imprintPage.leftColumn.bordOfTheHVB' | translate}}<br><br><br>
      {{'imprintPage.leftColumn.creationOfTheWebPresence' | translate}}<br>
      {{'imprintPage.leftColumn.ppi' | translate}}<br>
    </div>
    <div>
      <b>{{'imprintPage.rightColumn.copyrightTitle' | translate}}</b>
      <br><br>
      {{'imprintPage.rightColumn.copyrightText' | translate}}
      <br><br><br>
      <b>{{'imprintPage.rightColumn.disclaimerTitle' | translate}}</b>
      <br><br>
      {{'imprintPage.rightColumn.disclaimerText' | translate}}
      <br><br><br>
      <b>{{'imprintPage.rightColumn.disclaimerForLinksTitle' | translate}}</b>
      <br><br>
      {{'imprintPage.rightColumn.disclaimerForLinksText' | translate}}
      <br>
      {{'imprintPage.rightColumn.disclaimerForLinksText2' | translate}}
    </div>
  </div>
</div>
<hvb-footer></hvb-footer>
